import React, { useState, useCallback, useEffect } from 'react';
import EdgeOrREST from '../../EdgeOrREST';
import Notification from '../../components/shared/notification.component';
import {
    makeStyles,
    Button,
    TextField,
    Checkbox,
    Switch,
    Tooltip,
    FormControlLabel,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Paper,
    Tabs,
    Tab,
    Box,
    Radio,
    FormControl,
    Stepper,
    Step,
    StepLabel,
    RadioGroup,
    MenuItem,
    CircularProgress,
} from '@material-ui/core';
import { Autocomplete, Skeleton } from '@mui/material';
import TreeItem from '@material-ui/lab/TreeItem';
import Typography from '@material-ui/core/Typography';
import GetAppIcon from '@material-ui/icons/GetApp';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PublishIcon from '@material-ui/icons/Publish';
import FolderIcon from '@material-ui/icons/Folder';
import ConfirmationDialog from '../confirmation-dialog.component';
import { useDispatch, useSelector } from 'react-redux'
import PhotometricAttributeSelector from '../photometice-attributes-menu/photometric-attribute-selector.component';
import PhotometricAttributeStreetlightSelector from '../photometice-attributes-menu/photometric-attribute-streetlight-selector.component';
import PhotometricUpload from './photometric-upload.component';
import PhotometricMediaUpload from '../photometric-media-upload.component';
import tourActions from '../../store/actions/tourActions';

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3} style={{ padding: 0 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function Group(props) {
    const classes = props.useTreeItemStyles();
    const { labelText, labelIcon: LabelIcon, labelInfo: LabelInfo, removeLuminaire: RemoveInfo, editGroupAttributes: EditGroupAttributes, color, bgColor, group, onUpdate, parentGroupId, name, ...other } = props;
    const [openDelete, setOpenDelete] = React.useState(false);
    const [openEdit, setOpenEdit] = React.useState(false);
    const [openSelectedDelete, setOpenSelectedDelete] = React.useState(false);
    const [editGroupError, setEditGroupError] = React.useState(false);
    const [attributeParams, setAttributeParams] = useState({});
    const [groupName, setGroupName] = React.useState(props.name);
    const [isPublish, setIsPublish] = React.useState(props.isPublish == 1 ? true : false);
    const [groupDescription, setGroupDescription] = React.useState(props.description);
    const [downloadType, setDownloadType] = React.useState("V2");
    const [snack, setSnack] = React.useState({
        open: false
    });
    const state = useSelector(state => state)
    const dispatch = useDispatch()
    const [openDownload, setOpenDownload] = React.useState(false);
    const [lowestGroups, setLowestGroups] = React.useState(other.lowestGroups);
    const [uploadOpen, setUploadOpen] = React.useState(false);
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();
    const isManufacturer = state.user.roles && state.user.roles.find(role => role.name === "manufacturer" || role.name === "admin");
    const [mediaUpload, setMediaUpload] = React.useState({
        data: [],
        fileNames: [],
        groupId: props.groupId,
        luminaireId: props.luminaireId,
        uploadType: []
    });
    const [selectedUplaodGroup, setSelectedUplaodGroup] = React.useState(other.currentGroup);
    const handleClose = () => {
        setSnack({
            ...snack,
            open: false
        });
    };

    useEffect(() => {
        console.log("isPublish", props.isPublish);
    }, [])

    const handleAttributeParams = useCallback((attributeParams) => {
        setAttributeParams(attributeParams);
    }, []);

    const handleMediaUpload = useCallback((mediaUpload) => {
        setMediaUpload(mediaUpload);
    }, []);

    const [editTab, setEditTabIndex] = React.useState(0);
    const handleEditTab = (event, value) => {
        setEditTabIndex(value);
    };

    const handleIspublishClicked = (event) => {
        setIsPublish(!isPublish);
    };

    const onClickDelete = (e) => {
        if (state.EnabledTour.helpMode) {
            dispatch(tourActions.UpdateHelpURL({ helpURL: "Delete Group" }))
            const video = document.getElementById("help-video")
            video.load();
            dispatch(tourActions.UpdateHelpText({ helpText: "This button lets you delete your group or luminaire." }))
        } else {
            setOpenDelete(true);
        }
    };

    const onClickRemoveSelected = (e) => {
        if (state.EnabledTour.helpMode) {
            dispatch(tourActions.UpdateHelpURL({ helpURL: "Remove Luminaires" }))
            const video = document.getElementById("help-video")
            video.load();
            dispatch(tourActions.UpdateHelpText({ helpText: "This button lets you remove selected luminaires from your tree. Ensure you select the luminaires you want to remove before pressing this button." }))
        } else {
            setOpenSelectedDelete(true);
        }
    };

    const onRemoveSelectedConfirmed = (confirmed) => {
        if (confirmed) {
            other.onRemoveConfirmed();
        }
        setOpenSelectedDelete(false);
    };

    const onDeleteConfirmation = (confirmed) => {
        if (confirmed) {
            EdgeOrREST(null, 'DELETE_GROUP_OR_GROUP_ITEM', onDeleteGroupOrGroupItem, { headers: { 'id': props.nodeId }, props: props });
        }
        setOpenDelete(false);
    };

    const onDeleteGroupOrGroupItem = (response) => {
        other.resetGotChildren();
        props.forceUpdate();
    };

    const handleEditDialogClose = () => {
        setOpenEdit(false);
    };

    const handleDownloadDialogClose = () => {
        setOpenDownload(false);
    };

    const onClickEditGroup = () => {
        setTimeout(() => { dispatch(tourActions.UpdateCurrentStep({ currentStep: state.EnabledTour.currentStep + 1 })) }, 50);
        if (state.EnabledTour.helpMode) {
            dispatch(tourActions.UpdateHelpURL({ helpURL: "Edit Group" }))
            const video = document.getElementById("help-video")
            video.load();
            dispatch(tourActions.UpdateHelpText({ helpText: "This button lets you edit your group or luminaire." }))
        } else {
            setOpenEdit(true);
        }
    };

    const onClickOpenDownload = () => {
        if (state.EnabledTour.helpMode) {
            dispatch(tourActions.UpdateHelpURL({ helpURL: "Export Group" }))
            const video = document.getElementById("help-video")
            video.load();
            dispatch(tourActions.UpdateHelpText({ helpText: "This button lets you export your groups into one of our given formats." }))
        } else {
            setOpenDownload(true)
        }

    }

    const onClickExportGroup = () => {
        if (downloadType == "V2") {
            EdgeOrREST(null, 'EXPORT_PHOTOMERTRIC_TREE', onExportTree, { headers: { 'id': props.nodeId } });
            // } else if (downloadType == "Spektd") {
            //     EdgeOrREST(null, 'EXPORT_TO_SPEKTD', onExport, { headers: { 'id': props.nodeId } });
        } else if (downloadType == "Selector") {
            EdgeOrREST(null, 'EXPORT_TO_SELECTOR', onExport, { headers: { 'groupId': props.nodeId, "luminaireId": 0 } });
        }
        setOpenDownload(false);
    };

    const onExportTree = (response) => {
        console.log("onExportTree", response);
        if (response && response.status == '200') {
            var mediaType = "data:application/x-gzip;base64,";
            var a = document.createElement('a');
            a.href = mediaType + response.data.base64zip;
            a.download = response.data.filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setSnack({
                open: true,
                message: "Export successful.",
                severity: 'success'
            });
        } else {
            setSnack({
                open: true,
                message: "Downloading of tree failed",
                severity: 'error'
            });
        }
    };

    const onExport = (response) => {
        console.log("onExport", response);
        if (response && response.status == '200') {
            setSnack({
                open: true,
                message: "Export successful",
                severity: 'success'
            });
        } else if (response.data) {
            if (response.data.message?.includes("all")) {
                setSnack({
                    open: true,
                    message: response.data.message,
                    severity: 'error'
                });
            }
            else {
                setSnack({
                    open: true,
                    message: response.data.message,
                    severity: 'warning'
                });
            }
        }
        else {
            setSnack({
                open: true,
                message: response.message,
                severity: 'error'
            });

        }
    };

    const editGorup = () => {
        setEditGroupError(true);
        EdgeOrREST(null, 'UPDATE_GROUP_NAME_DESCRIPTION', onUpdateGroupNameDescription, { 'id': props.nodeId, name: groupName, description: groupDescription, isPublish: isPublish ? 1 : 0 });
        EdgeOrREST(null, 'UPDATE_GROUP_ATTRIBUTES', onUpdateGroupAttributes, { id: props.nodeId, attributeParams: attributeParams });
        EdgeOrREST(null, 'UPLOAD_MEDIA_FOR_LUMINAIRES', onUploadMedia, mediaUpload);
        setOpenEdit(false);
        setEditGroupError(false);
        setTimeout(() => { dispatch(tourActions.UpdateCurrentStep({ currentStep: state.EnabledTour.currentStep + 1 })) }, 50);
    };

    const onUploadMedia = (response) => {
        console.log("onUploadMedia", response);
        if (response.status == 200) {
            setSnack({
                open: true,
                message: "Files uploaded successfully",
                severity: 'success'
            });
        } else {
            setSnack({
                open: true,
                message: response.status + response.message,
                severity: 'error'
            });
        }
    };

    const onUpdateGroupNameDescription = (response) => {
        console.log("onUpdateGroupNameDescription", response);
    };

    const onUpdateGroupAttributes = (response) => {
        console.log("onUpdateGroupAttributes", response);
        if (response.status == 200) {
            setSnack({
                open: true,
                message: "Group attributes update successful.",
                severity: 'success'
            });
        } else {
            setSnack({
                open: true,
                message: response.status + response.message,
                severity: 'error'
            });
        }
        other.resetGotChildren();
        props.forceUpdate();
    };

    const handleUploadClose = () => {
        setUploadOpen(false);
        setActiveStep(0);
    };

    const handleUploadClick = () => {
        if (state.EnabledTour.helpMode) {
            dispatch(tourActions.UpdateHelpURL({ helpURL: "Add Luminaires" }))
            const video = document.getElementById("help-video")
            video.load();
            dispatch(tourActions.UpdateHelpText({ helpText: "This button lets you add luminaires to your groups." }))
        } else {
            setLowestGroups(other.lowestGroups);
            setSelectedUplaodGroup(lowestGroups.find(group => group.id === props.nodeId));
            setUploadOpen(true);
            setTimeout(() => { dispatch(tourActions.UpdateCurrentStep({ currentStep: state.EnabledTour.currentStep + 1 })) }, 50);
        }
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setTimeout(() => { dispatch(tourActions.UpdateCurrentStep({ currentStep: state.EnabledTour.currentStep + 1 })) }, 50);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    function getSteps() {
        return ['Select Group for the Luminaire(s)', 'Upload Luminaire(s)'];
    }

    //step content
    function getStepContent(stepIndex) {
        switch (stepIndex) {
            case 0:
                return (
                    <div style={{ marginLeft: '10px' }}>
                        <h6>{'Please select a group.'}</h6>
                        {'*First group is selected by default if no group is selected'}
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                            <SelectGroup />
                        </div>
                    </div>);
            case 1:
                return (
                    <>
                        <DialogContentText style={{ marginLeft: '10px' }}> {'Upload Luminaire(s) and select attributes for luminaires'}</DialogContentText>
                        <DialogContentText style={{ marginLeft: '10px' }}> {'Only selected attributes will be assigned to the luminaires'}</DialogContentText>
                        <PhotometricUpload groupId={selectedUplaodGroup ? selectedUplaodGroup.id : lowestGroups[0]} resetGotChildren={other.resetGotChildren}
                            setExpanded={other.setExpanded} expanded={other.expanded} setGotChildren={other.setGotChildren} gotChildren={other.gotChildren}
                        />
                    </>
                );
            default:
                return 'Unknown stepIndex';
        }
    }

    function checkForManufacturerPriv() {
        var isManu = false;
        if (state.user.roles) {
            for (var i = 0; i < state.user.roles.length; i++) {
                if (state.user.roles[i].name === "manufacturer") {
                    isManu = true;
                }
            }
        }
        return isManu;
    }

    const handleSelectedGroup = (event, value) => {
        setSelectedUplaodGroup(value);
        console.log("value", value);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    function SelectGroup() {
        console.log("selectedUplaodGroup", selectedUplaodGroup);
        return (
            <>
                <FormControl className={classes.formControl} style={{ width: 250, }}>
                    <Autocomplete
                        id="multiple-limit-tags"
                        options={lowestGroups}
                        onChange={handleSelectedGroup}
                        value={selectedUplaodGroup}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" label={<Typography>Select Groups</Typography>} />
                        )}
                    />
                </FormControl>
            </>
        );
    }

    const stepIcons = {
        1: <FolderIcon />,
        2: <UploadFileIcon />,
    };

    return (
        <>
            <TreeItem
                label={
                    <div className={classes.labelRoot}>
                        <Tooltip title={props?.description}>
                            <LabelIcon color="inherit" className={classes.labelIcon} />
                        </Tooltip>
                        <Typography variant="body2" className={classes.labelText}>
                            {labelText}
                        </Typography>
                        <Typography variant="caption" color="inherit">
                            <Tooltip title="Add Luminaire">
                                {other.isLowest ? <PublishIcon color="inherit" className={classes.label} onClick={handleUploadClick} /> : <></>}
                            </Tooltip>
                            <Tooltip title="Download">
                                <GetAppIcon color="inherit" className={classes.label} onClick={onClickOpenDownload} />
                            </Tooltip>
                            <Tooltip title="Edit Attributes">
                                <EditGroupAttributes color="inherit" className={classes.label} onClick={onClickEditGroup} />
                            </Tooltip>
                            <Tooltip title="Remove Selected Luminaires">
                                <RemoveInfo color="inherit" className={classes.label} onClick={onClickRemoveSelected} />
                            </Tooltip>
                            <Tooltip title="Delete">
                                <LabelInfo color="inherit" className={classes.label} onClick={onClickDelete} />
                            </Tooltip>
                        </Typography>
                    </div>
                }
                style={{
                    '--tree-view-color': color,
                    '--tree-view-bg-color': bgColor,
                }}
                classes={{
                    root: classes.root,
                    content: classes.content,
                    expanded: classes.expanded,
                    group: classes.group,
                    label: classes.label,
                }}
                {...other}
            />

            <Dialog
                className='manageStep5'
                open={uploadOpen}
                onClose={handleUploadClose}
                classes={{ paper: classes.dialogPaper }}
            >
                <DialogTitle>Add Luminaire</DialogTitle>
                <Stepper activeStep={activeStep} alternativeLabel >
                    {steps.map((label, index) => (
                        <Step key={label} >
                            <StepLabel StepIconComponent={() =>
                                index < activeStep ? <CheckCircleIcon /> : stepIcons[index + 1]
                            }>
                                {label}
                            </StepLabel>
                        </Step>
                    ))}
                </Stepper>

                {
                    <>
                        <Typography>{getStepContent(activeStep)}</Typography>
                        <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'flex-end', marginRight: '10px', marginBottom: '10px' }}>
                            <Button disabled={activeStep === 0} display={activeStep !== 0} onClick={handleBack}>
                                Back
                            </Button>
                           {activeStep === 0 ?  <Button disabled={activeStep !== 0} variant="contained" color="primary" onClick={handleNext}>{'Next'}</Button> : <></>}
                            {activeStep !== 0 ? <Button variant="contained" color="primary" onClick={handleUploadClose}>{'Close'}</Button> : <></>}
                        </div>
                    </>
                }

            </Dialog>
            <Dialog
                className='manageStep10'
                open={openEdit}
                onClose={handleEditDialogClose}
                classes={{ paper: classes.dialogPaper }}
            >
                <DialogTitle>Edit Group</DialogTitle>
                <DialogContent >
                    <TextField
                        error={editGroupError}
                        autoFocus
                        margin="dense"
                        label="Enter Name"
                        id="standard-name"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={groupName}
                        onChange={(e) => setGroupName(e.target.value)}
                    />
                    <TextField
                        margin="dense"
                        label="Enter Description"
                        type="text"
                        fullWidth
                        id="standard-name"
                        defaultValue=""
                        value={groupDescription}
                        onChange={(e) => setGroupDescription(e.target.value)}
                        inputProps={{ maxLength: 250 }}
                    />
                    <Paper square>
                        <Tabs
                            value={editTab}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                            onChange={handleEditTab}
                        >
                            <Tab index={0} name="lighting" label="street lighting"  {...a11yProps(0)} value={0} />
                            {/* <Tab index={1} label="Spektd" {...a11yProps(1)} value={1} /> */}
                        </Tabs>
                    </Paper>
                    <TabPanel value={editTab} index={0}>
                        <PhotometricAttributeStreetlightSelector handleAttributeParams={handleAttributeParams} edit={true} groupId={props.nodeId} parentGroupId={props.parentGroupId} />
                    </TabPanel>
                    {/* <TabPanel value={editTab} index={1}>
                        <PhotometricAttributeSelector handleAttributeParams={handleAttributeParams} edit={true} groupId={props.nodeId} parentGroupId={props.parentGroupId} />
                        <PhotometricMediaUpload groupId={props.nodeId} luminaireId={0} handleMediaUpload={handleMediaUpload} />
                    </TabPanel> */}

                    {checkForManufacturerPriv() ?
                        <Typography>Published:
                            <Switch color="primary" checked={isPublish} onClick={handleIspublishClicked} />
                        </Typography> : <></>
                    }
                </DialogContent>
                <div style={{ textAlign: "right", margin: 10 }}>
                    <Button disabled={!groupName || groupName.length <= 0} variant="contained" color="primary" onClick={editGorup}>
                        Save
                    </Button>
                </div>
            </Dialog>
            <Dialog
                open={openDownload}
                onClose={handleDownloadDialogClose}
                classes={{ paper: classes.dialogPaper }}
            >
                <DialogTitle>Export Group</DialogTitle>
                <DialogContent >
                    <RadioGroup value={downloadType} onChange={event => setDownloadType(event.target.value)} color="primary">
                        <FormControlLabel value="V2" control={<Radio />} label="Lighting Reality Pro V2" />
                        {/* <FormControlLabel value="Spektd" control={<Radio />} label="LR Spektd" /> */}
                        <FormControlLabel value="Studio" control={<Radio disabled />} label="LR Studio" />
                        <FormControlLabel value="Selector" control={<Radio disabled={!isManufacturer} />} label="LR Selector" />
                    </RadioGroup>
                    <div style={{ textAlign: "right" }}>
                        <Button disabled={!groupName || groupName.length <= 0} variant="contained" color="primary" onClick={onClickExportGroup}>
                            Export
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
            <ConfirmationDialog confirm={onDeleteConfirmation} open={openDelete} title={"Delete " + props.type.charAt(0).toUpperCase() + props.type.slice(1)} text={"Do you wish to delete " + props.labelText + "?"}></ConfirmationDialog>
            <ConfirmationDialog confirm={onRemoveSelectedConfirmed} open={openSelectedDelete} title={"Remove Selected Luminaires"} text={"Do you wish to remove the selected Luminaire(s)?"}></ConfirmationDialog>
            <Notification onClose={handleClose} open={snack.open} severity={snack.severity} message={snack.message}></Notification>
        </>

    );
}

export default React.memo(Group);